import { useState } from "react";
import domain from "../domain";
import classes from "./ApiRequestForm.module.css";

export default function ApiRequestForm() {
  const [method, setMethod] = useState("GET");
  const [endpoint, setEndpoint] = useState("/api/");
  const [bodyText, setBodyText] = useState("{\n  \n}");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    const options = {
      method,
      credentials: "include",
      headers: {},
    };

    if (method === "POST" || method === "PATCH") {
      try {
        options.body = JSON.stringify(JSON.parse(bodyText));
        options.headers["Content-Type"] = "application/json";
      } catch {
        setResult({ error: "Body must be valid JSON" });
        setLoading(false);
        return;
      }
    }

    try {
      const res = await fetch(`${domain}${endpoint}`, options);
      const text = await res.text();
      let body;
      try {
        body = text ? JSON.parse(text) : "(empty response)";
      } catch {
        body = text;
      }
      setResult({ status: res.status, ok: res.ok, body });
    } catch (err) {
      setResult({ error: err.message });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={classes.container}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <p>
          <label htmlFor="method">Method</label>
          <select
            id="method"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
          >
            <option value="GET">GET</option>
            <option value="POST">POST</option>
            <option value="PATCH">PATCH</option>
          </select>
        </p>
        <p>
          <label htmlFor="endpoint">Endpoint</label>
          <input
            id="endpoint"
            type="text"
            value={endpoint}
            onChange={(e) => setEndpoint(e.target.value)}
            placeholder="/api/questions"
            required
          />
        </p>
        {(method === "POST" || method === "PATCH") && (
          <p>
            <label htmlFor="body">Body (JSON)</label>
            <textarea
              id="body"
              rows={8}
              value={bodyText}
              onChange={(e) => setBodyText(e.target.value)}
              spellCheck={false}
            />
          </p>
        )}
        <div className={classes.actions}>
          <button type="submit" disabled={loading}>
            {loading ? "Sending…" : "Send"}
          </button>
        </div>
      </form>

      <section className={classes.response}>
        <h2>Response</h2>
        {loading && <p className={classes.loading}>Sending…</p>}
        {result?.error && <p className={classes.error}>{result.error}</p>}
        {result && !result.error && (
          <>
            <p
              className={
                result.ok ? classes.statusOk : classes.statusError
              }
            >
              Status: {result.status} {result.ok ? "OK" : "Error"}
            </p>
            <pre className={classes.body}>
              {typeof result.body === "string"
                ? result.body
                : JSON.stringify(result.body, null, 2)}
            </pre>
          </>
        )}
      </section>
    </div>
  );
}
